import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Autocomplete, Button, Popup, ScrollView, SelectBox } from 'devextreme-react';
import { useDispatch, useSelector } from 'react-redux';
import { closeDialog, openItemDialog, setItemTypeId } from '../../store/item/itemDialogReducer'
import { store } from '../../services/store';
import uri from '../../utils/uri';
import { createCustomStore, createStore } from '../../utils/proxy';
import Form, { EmptyItem, GroupItem, Item, Label, RequiredRule, SimpleItem, StringLengthRule } from 'devextreme-react/form';
import http from '../../utils/http';
import notify from 'devextreme/ui/notify';
import { closeEditDialog } from '../../store/editDialog/editDialogReducer';
import DataSource from 'devextreme/data/data_source';



const defualtItem = {
  id: 0,
  name: '',
  value: null,
  parentId:null,
  names:[],
  catalogs:[],
};


const EditCatalogEntryDialog = (props) => {

  const { updateParent } = props;

  let dispatch = useDispatch();
  const [item, setItem] = useState(defualtItem);
  const { editDialog } = useSelector((store) => store);

  const formRef = useRef();

  const onLoad = (id) => {
    Promise.all([
      http(uri.masterCatalogs.get+`/${id}`).asGet(),
      http(uri.catalogEntriesSearch).asGet()
    ]).then(result => {

      var r = {
        ...item,
        ...result[0],
        names:[...new Set(result[1].map(x=>x.catalog))] ,
        catalogs: result[1] 
      };
      setItem(r);
    });
  }

  const loadCatalogs = () => {

    Promise.all([
      http(uri.catalogEntriesSearch).asGet()
    ]).then(result => {
     
      setItem(prev=>{ return  {
        ...prev,
        names:[...new Set(result[0].map(x=>x.catalog))] ,
        catalogs: result[0] 
      }});

    });
  }

 
  useEffect(() => {

    if (editDialog.id != null && editDialog.id != 0) {
      onLoad(editDialog.id);
    } else {
      setItem({ ...defualtItem });
      //Cargar Catalogos
      loadCatalogs();
    }
  }, [editDialog.id]);

  let editable = true;

  const guardarItem = (params) => {

    if (formRef.current.instance.validate().isValid) {
      let data = {
        ...item
      }
      http(uri.masterCatalogs.insert).asPost(data).then(resp => {
        notify('Datos guardados correctamente');
        dispatch(closeEditDialog());
        updateParent();
        setItem({...defualtItem});
      }).catch(err => notify(err, 'error'))
    }
  }

  return (
    <Popup width={800} minHeight={275} maxHeight={350} title={`${item.id == 0 ? 'Agregar' : 'Editar'} Catalogo`} visible={editDialog.open} onHiding={() => { dispatch(closeEditDialog()) }}>
      <ScrollView showScrollbar="onScroll">
        <Form formData={item} ref={formRef}>
          <GroupItem cssClass="second-group" colCount={2}>
            <SimpleItem dataField="name"  editorType="dxAutocomplete" editorOptions={{dataSource:item.names} }  >
              <Label text="Catalogo" />
              <RequiredRule message="Este campo es requerido" />
              <StringLengthRule max={50} message="Maximo 50 caracteres" />
            </SimpleItem>
  
            <SimpleItem dataField="value" >
              <Label text="Valor" />
              <RequiredRule message="Este campo es requerido" />
            </SimpleItem>
           

            <SimpleItem dataField="parentId" editorType="dxLookup" editorOptions={{ dataSource:new DataSource({store: item.catalogs,key:'id', group:'catalog'}), grouped:true,showClearButton:true,  valueExpr: "id", displayExpr: "value" }}>
              <Label text="Padre" />
            </SimpleItem>
            
            <EmptyItem></EmptyItem>
           
          </GroupItem>




        </Form>
        <br />
        <Button
          width={180}
          text="Guardar"
          type="default"
          icon='save'
          onClick={guardarItem}
        />
        <br />

      </ScrollView>
    </Popup>

  );
};


EditCatalogEntryDialog.propTypes = {

};


export default EditCatalogEntryDialog;
